<!-- <template>
  <div id="centerRight2" style="position: relative; overflow: hidden;">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <span class="fs-xl text mx-2">健康档案人数</span>
      </div>
      <div class="d-flex ai-center flex-column body-box">
        <dv-capsule-chart class="dv-cap-chart" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      config: {
        data: [
          {
            name: '三高',
            value: 5000
          },
          {
            name: '冠心病',
            value: 4900
          },
          {
            name: '脑卒中',
            value: 4800
          },
          {
            name: '肾病综合征',
            value: 4700
          },
          {
            name: '眼底病变',
            value: 4600
          },
		  {
		    name: '周围神经病变',
		    value: 4500
		  },
		  {
		    name: '周围血管病变',
		    value: 4400
		  },
		  {
		    name: '慢阻肺',
		    value: 4300
		  },
		  {
		    name: '先天性心脏病',
		    value: 4200
		  },
		  {
		    name: '心肌炎',
		    value: 4100
		  },
		  {
		    name: '眩晕综合征',
		    value: 4000
		  },
		  {
		    name: '偏头痛',
		    value: 3900
		  },
		  {
		    name: '慢性肺源性心脏病',
		    value: 3800
		  },
		  {
		    name: '高脂血症',
		    value: 3700
		  },
		  {
		    name: '肺结核',
		    value: 3600
		  },
		  {
		    name: '癫痫',
		    value: 3500
		  },
		  {
		    name: '阿尔茨海默病',
		    value: 3400
		  },
		  {
		    name: '帕金森病',
		    value: 3300
		  },
		  {
		    name: '先天性心脏病',
		    value: 3200
		  },
		  {
		    name: '精神分裂症',
		    value: 3100
		  },
		  {
		    name: '双向情感障碍',
		    value: 3000
		  },
		  {
		    name: '抑郁症',
		    value: 2900
		  },
        ]
      }
    }
  },
  components: {  }
}
</script>

<style lang="scss" scoped>
#centerRight2 {
  padding: 5px;
  height: 500px;
  width: 98%;
  border-radius: 5px;
  .bg-color-black {
    padding: 5px;
    height: 500px;
    width: 98%;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
	margin-top: -10px !important;
    .dv-cap-chart {
      width: 100%;
      height: 480px;
    }
  }
}
</style>
 -->
 <template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">健康档案人数</span>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
        <!-- <dv-scroll-board class="dv-scr-board" :config="config" /> -->
         <dv-capsule-chart class="dv-cap-chart" :config="config" />
      </div>
    </div>
  </div>
</template>
 
 <script>
import request from '@/utils/request';
export default {
  data() {
    return {
       config: {
        data: [],
        // unit: '人',
        showValue:true
      }
    }
  },
  components: {},
  mounted() { },
  methods: {},
  created() {
    request({
      url: this.$root.api + `/api/dbz/daping/dpdbzjcszorjkda/jkdars`,
      method: 'get',
      data: {
        code: "",
      }
    }).then(res => {
      console.log('jkdars---健康档案', res)
      // let resdata = res.data;
      let resdata = [["慢性肾功能不全","155555"],["血脂异常","200"],["脑梗塞","0"],["冠心病脑出血","0"],["肾病综合征","0"],["类风湿性关节炎","0"],["三高","654535"],["慢阻肺","10"]]
        // let resdata=[["昌乐县","75625"],["安丘市","95551"],["滨海","45625"],["昌邑市","65265"],["坊子区","45685"],["高密市","98956"],["高新区","58652"],["寒亭区","59256"],["奎文区","46251"],["临朐县","89562"],["青州市","95625"],["寿光市","146525"],["潍城区","52565"],["潍坊市直","0"],["峡山区","35625"],["诸城市","122562"]]
      let cdata = this.config;
      resdata.forEach(child => {
        let obj = {};
        obj.name = child[0]
        obj.value = child[1]
        cdata.data.push(obj)
      });
      this.config = { ...cdata }
      console.log('jkdars---config', this.config)
    })
  },
}
</script>
 
 <style lang="scss" scoped>
 #centerRight1 {
   padding: 16px;
   padding-top: 20px;
   height: 500px;
   width: 100%;
   border-radius: 5px;
 
   .bg-color-black {
     height: 480px;
     border-radius: 10px;
   }
 
   .text {
     color: #c3cbde;
   }
 
   .body-box {
     border-radius: 10px;
     overflow: hidden;
 
     .dv-cap-chart{
       width: 100%;
       height: 440px;
     }
   }
 }
 ::v-deep.dv-capsule-chart {
     position: relative;
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     -webkit-box-orient: horizontal;
     -webkit-box-direction: normal;
     -ms-flex-direction: row;
     flex-direction: row;
     -webkit-box-sizing: border-box;
     box-sizing: border-box;
     padding: 5px;
     color: #fff;
 }
 ::v-deep.dv-capsule-chart .label-column {
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     -webkit-box-orient: vertical;
     -webkit-box-direction: normal;
     -ms-flex-direction: column;
     flex-direction: column;
     -webkit-box-pack: justify;
     -ms-flex-pack: justify;
     justify-content: space-between;
     -webkit-box-sizing: border-box;
     box-sizing: border-box;
     padding-right: 5px;
     text-align: right;
     font-size: 12px;
 }

 ::v-deep.dv-capsule-chart .capsule-item .capsule-item-column .capsule-item-value {
     font-size: 12px;
     -webkit-transform: translateX(0%);
     transform: translateX(0%);
 }
 ::v-deep.dv-capsule-chart .capsule-item .capsule-item-column {
     position: relative;
     height: 8px;
     margin-top: 1px;
     border-radius: 5px;
     -webkit-transition: all 0.3s;
     transition: all 0.3s;
     display: -webkit-box;
     display: -ms-flexbox;
     display: flex;
     -webkit-box-pack: end;
     -ms-flex-pack: end;
     justify-content:flex-start;
     -webkit-box-align: center;
     -ms-flex-align: center;
     align-items: center;
 }
 </style>
 